/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV3ServiceActivateTicketPost } from '../fn/ticket/api-v-3-service-activate-ticket-post';
import { ApiV3ServiceActivateTicketPost$Params } from '../fn/ticket/api-v-3-service-activate-ticket-post';
import { apiV3ServiceListPurchaseSourceGet } from '../fn/ticket/api-v-3-service-list-purchase-source-get';
import { ApiV3ServiceListPurchaseSourceGet$Params } from '../fn/ticket/api-v-3-service-list-purchase-source-get';
import { apiV3ServiceListPurchaseSourceGet$Plain } from '../fn/ticket/api-v-3-service-list-purchase-source-get-plain';
import { ApiV3ServiceListPurchaseSourceGet$Plain$Params } from '../fn/ticket/api-v-3-service-list-purchase-source-get-plain';
import { PurchaseSourceApiFrom } from '../models/purchase-source-api-from';

@Injectable({ providedIn: 'root' })
export class ApiFromTicketService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV3ServiceActivateTicketPost()` */
  static readonly ApiV3ServiceActivateTicketPostPath = '/api/v3/service/ActivateTicket';

  /**
   * ticket activation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceActivateTicketPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceActivateTicketPost$Response(params?: ApiV3ServiceActivateTicketPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceActivateTicketPost(this.http, this.rootUrl, params, context);
  }

  /**
   * ticket activation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceActivateTicketPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceActivateTicketPost(params?: ApiV3ServiceActivateTicketPost$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceActivateTicketPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceListPurchaseSourceGet()` */
  static readonly ApiV3ServiceListPurchaseSourceGetPath = '/api/v3/service/ListPurchaseSource';

  /**
   * Getting a list of ticket payment sources.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListPurchaseSourceGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListPurchaseSourceGet$Plain$Response(params?: ApiV3ServiceListPurchaseSourceGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PurchaseSourceApiFrom>>> {
    return apiV3ServiceListPurchaseSourceGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of ticket payment sources.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListPurchaseSourceGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListPurchaseSourceGet$Plain(params?: ApiV3ServiceListPurchaseSourceGet$Plain$Params, context?: HttpContext): Observable<Array<PurchaseSourceApiFrom>> {
    return this.apiV3ServiceListPurchaseSourceGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PurchaseSourceApiFrom>>): Array<PurchaseSourceApiFrom> => r.body)
    );
  }

  /**
   * Getting a list of ticket payment sources.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListPurchaseSourceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListPurchaseSourceGet$Response(params?: ApiV3ServiceListPurchaseSourceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PurchaseSourceApiFrom>>> {
    return apiV3ServiceListPurchaseSourceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of ticket payment sources.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListPurchaseSourceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListPurchaseSourceGet(params?: ApiV3ServiceListPurchaseSourceGet$Params, context?: HttpContext): Observable<Array<PurchaseSourceApiFrom>> {
    return this.apiV3ServiceListPurchaseSourceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PurchaseSourceApiFrom>>): Array<PurchaseSourceApiFrom> => r.body)
    );
  }

}
